import { TranscriptSource } from "@/types/transcript";
export const isChatSourced = (segment) => segment.source === TranscriptSource.Chat ||
    segment.source === TranscriptSource.Backroom ||
    segment.source === TranscriptSource.Private;
export const transcriptIndexOf = (segment) => segment.sourceIndex ?? segment.id;
